// extracted by mini-css-extract-plugin
export default {"lightgrey":"#2b2a29","gnieznored":"#e31e24"};